// extracted by mini-css-extract-plugin
export var gameOver = "board-module--gameOver--yIGjV";
export var gameWrap = "board-module--gameWrap--CY-id";
export var tileGrid = "board-module--tileGrid--RbWv2";